import { AwardRestrictionsFormValuesPaths } from './award-restrictions.types';

export const defaultFieldNamePrefix = 'awardRestrictions';
export const defaultConstraintEnabledFieldName: AwardRestrictionsFormValuesPaths = 'isEnabled';
export const defaultConstraintAwardsFieldName: AwardRestrictionsFormValuesPaths = 'awards';
